import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { RouteErrorFallback } from '@/components/ErrorBoundary'
import {
  PageContainer, PageCard, PageHeader, PageHeaderContent,
  PageHeaderTitle, PageHeaderHeading, PageHeaderDescription, PageContent
} from '@/components/ui/page'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { BillingOverviewCards } from '@/components/admin/billing/BillingOverviewCards'
import { BillingUsageChart } from '@/components/admin/billing/BillingUsageChart'
import { BillingOrganizationsTable } from '@/components/admin/billing/BillingOrganizationsTable'
import { BillingOrganizationSelect } from '@/components/admin/billing/BillingOrganizationSelect'

export const Route = createFileRoute('/admin/billing/')({
  component: BillingAdmin,
  errorComponent: RouteErrorFallback,
})

function BillingAdmin() {
  const [activeTab, setActiveTab] = useState('usage')
  const [selectedOrgId, setSelectedOrgId] = useState<string | null>(null)

  return (
    <PageContainer>
      <PageCard>
        <PageHeader>
          <PageHeaderContent>
            <PageHeaderTitle>
              <PageHeaderHeading>Abrechnung</PageHeaderHeading>
              <PageHeaderDescription>Verwaltung der Abrechnung</PageHeaderDescription>
            </PageHeaderTitle>
          </PageHeaderContent>
        </PageHeader>
        <PageContent className="overflow-y-auto">
          <div className="flex flex-col gap-4 p-4 flex-1 min-h-0">
            <BillingOverviewCards />
            <Tabs
              value={activeTab}
              onValueChange={setActiveTab}
              className="flex flex-1 flex-col min-h-0"
            >
              <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                <TabsList className="w-fit">
                  <TabsTrigger value="usage">Nutzung</TabsTrigger>
                  <TabsTrigger value="organizations">Organisationen</TabsTrigger>
                </TabsList>
                {activeTab === 'usage' && (
                  <BillingOrganizationSelect
                    value={selectedOrgId}
                    onChange={setSelectedOrgId}
                    className="w-full sm:w-64"
                  />
                )}
              </div>
              <TabsContent value="usage" className="flex-1 min-h-0">
                <div className="grid grid-rows-2 gap-4 h-full">
                  <BillingUsageChart
                    timeRange="woche"
                    organizationId={selectedOrgId}
                    className="min-h-64"
                  />
                  <BillingUsageChart
                    timeRange="monat"
                    organizationId={selectedOrgId}
                    className="min-h-64"
                  />
                </div>
              </TabsContent>
              <TabsContent value="organizations" className="flex-1 min-h-0">
                <BillingOrganizationsTable className="h-full" />
              </TabsContent>
            </Tabs>
          </div>
        </PageContent>
      </PageCard>
    </PageContainer>
  )
}
